import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { InitAiLab } from '@/infrastructure/api-functions/interface/init-ai-lab.interface';


export const AiLabService = Symbol('AiLabService');
export interface AiLabService {
    surplusTimes: number;
    permissions: { [key:string]: boolean }
    initAiLab: () => Promise<void>;
}

@injectable()
export class AiLabServiceImpl implements AiLabService {
    public surplusTimes = 0;
    public permissions = {};
    constructor(
        @inject(InitAiLab)
        private initAiLabApi: InitAiLab,
    ) { }

    async initAiLab() {
        const data = await this.initAiLabApi.initAiLab();
        this.surplusTimes = data.total_times - data.used_times;
        this.permissions = data.permissions || {};
    }
}